"use strict";
/**
 * Created on 07 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceTerminationUpload_1 = require("../../../price-termination/model/PriceTerminationUpload");
/**
 * <p>Upload summary of data related to {@link SelloutTermination}.</p>
 *
 * <p><b>If the uploaded file does not fulfill basic conditions such as file data format, data structure, etc., there wont'be created
 * any associated {@link SelloutTerminationUploadedItem} related to the upload.</b></p>
 *
 * @author JMe
 */


var SelloutTerminationUpload =
/*#__PURE__*/
function (_PriceTerminationUplo) {
  _inherits(SelloutTerminationUpload, _PriceTerminationUplo);

  function SelloutTerminationUpload() {
    _classCallCheck(this, SelloutTerminationUpload);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationUpload).apply(this, arguments));
  }

  return SelloutTerminationUpload;
}(PriceTerminationUpload_1.PriceTerminationUpload);

exports.SelloutTerminationUpload = SelloutTerminationUpload;